<template>
	<el-container>
		<el-tabs style="width: 100%;" type="border-card">
			<el-tab-pane label="体检套餐">
				<span slot="label">
					
						<span style="font-size: 24px;padding-left: 8px;width: 50%;">体检套餐</span>
					
				</span>
				<el-row>
					<el-col :span="24">
						<!-- <el-header style=" float: left;"> -->
						<el-button type="text" @click="ShowCart()">我的购物车</el-button>
						<el-input v-model="select_word" @keyup.enter.native="search()" placeholder="套餐名称搜索" style="display:inline-block;width:150px;"></el-input>
						<!-- </el-header> -->
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-select @change="InitCorpGoodsType" size="mini" style=" height:20px;" v-model="curcorpid" placeholder="请选择体检机构">
							<el-option v-for="item in CorpData" :label="item.corp_name" :value="item.corp_id">
								{{ item.corp_name }}
							</el-option>
						</el-select>
					</el-col>
					<el-col :span="12">
						<el-select size="mini" @change="SelGoodsTypeChange" style=" width: 100%;  height:20px;" v-model="curgoods_typeid"
						 placeholder="请选择套餐类型">
							<el-option v-for="gtype in goodstypelist" :label="gtype.typename" :value="gtype.id">
								{{ gtype.typename }}
							</el-option>
						</el-select>
					</el-col>
				</el-row><!-- @expand-change="expandChange" -->
				<el-table size="mini" ref="singleTable" highlight-current-row :data="GetShowGoods()">
					<el-table-column type="expand" width="1">
						<template slot-scope="props">
							<div>
								<el-table :data="props.row.goodsitemlist" style="width: 100%">
									<el-table-column type="index">
									</el-table-column>
									<el-table-column prop="SaleModuleName" label="项目名称" width="180">
									</el-table-column>
									<el-table-column prop="FNote" label="临床意义" width="380">
									</el-table-column>
								</el-table>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="goods_address" width="60px">
						<template slot-scope="scope">


							<img style="max-width: 50px;" :src='"/img"+ scope.row.goods_address'>

						</template>
					</el-table-column>
					<el-table-column prop="goods_name">
						<template slot-scope="scope">
							<li style="font-size: 15px;">{{scope.row.goods_type}}</li>
							<li>{{scope.row.goods_name}}</li>
							<li>￥{{scope.row.goods_saleprice}}</li>
							<li>
								<el-button size="mini" round type="danger" @click="AddToShopCart(scope.row)">加入购物车</el-button>
							</li>

						</template>
					</el-table-column>
					<el-table-column prop="goods_detail">
						<template slot-scope="scope">
							<li style="font-size: 15px;">描述：</li>
							<li>{{scope.row.goods_detail}}</li>
							<li>
								<el-button size="mini" round type="success" @click="expandChange(scope.row)">套餐详情</el-button>
							</li>

						</template>
					</el-table-column>
				</el-table>
				<el-button v-if="goodslist.length>goodsshowcount" type="text" @click="AddGoodsShow()">继续加载</el-button>

				<el-drawer :visible.sync="showshopcart" :with-header="false" :size='size'>
					<myshopcart v-if='showshopcart'></myshopcart>
				</el-drawer>
			</el-tab-pane>
			<el-tab-pane>
				<span slot="label">
					
						<span style="font-size: 24px;padding-left: 8px;width: 50%;">健康知识</span>
					
				</span>
			</el-tab-pane>
		</el-tabs>
	</el-container>
</template>

<script>
	import goods from '../../apifunction/Goods.js'
	import member from '../../apifunction/Member.js'
	import corp from '../../apifunction/Corp.js'
	import myshopcart from '../Member/MyShopCart.vue'
	export default {
		created() {
			this.userent = this.$myglobal.getUserInfo();
			this.getAllCorp();
		},
		components: {
			myshopcart
		},
		data() {
			return {
				size: '300px',
				userent: null,
				CorpData: [],
				curcorpid: '',
				goodstypelist: [],
				goodslisttemp: [],
				goodslist: [],
				goodsshowcount: 1,
				curgoods_typeid: '',
				select_word: "",
				tabPosition: 'left',
				showshopcart: false,
				curselGoods: null
			}
		},
		methods: {
			expandChange(row) {
				if (row.goodsitemlist.length < 1) {
					goods.GetGoodsItemWithFNoteByGoodsid(row.corpid, row.goods_id)
						.then(res => {
							let ent = JSON.parse(JSON.stringify(res.data));
							if (ent.Flag == 'success') {
								if (ent.Data == 'null')
									return;
								row.goodsitemlist = JSON.parse(ent.Data);
								this.$refs.singleTable.toggleRowExpansion(row);
							}
						})
				} else
					this.$refs.singleTable.toggleRowExpansion(row);
			},
			GetGoodsItems: function(goodsent, expandedRows) {
				// this.goodslist[index].goodsitemlist=[]



			},
			ShowCart() {
				this.showshopcart = true;
			},
			AddToShopCart(row) {
				var info = {
					mobile: this.userent.mobile,
					goods_id: row.goods_id,
					goods_count: 1
				}
				member.AddShopCart(info)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.$message.info('添加成功！');
						} else
							this.$message.info(ent.Msg);
					})
			},
			search() {
				this.goodslist = this.goodslisttemp.filter(item => {

					if (item.goods_name.indexOf(this.select_word) > -1) {
						return item;
					}
				});
			},
			togoodsitem(row) {
				var data = {
					path: '/goodsitem',
					query: {
						ent: JSON.stringify(row)
					}
				};
				this.$router.push(data)
			},
			getAllCorp() {
				corp.GetAllCorp()
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							if (ent.Data != 'null') {
								this.CorpData = JSON.parse(ent.Data);
								this.curcorpid = this.CorpData[0].corp_id;
								this.InitCorpGoodsType();
							}

						} else
							this.$message.info(ent.Msg);
					})
			},
			InitCorpGoodsType() {
				if (this.curcorpid == '')
					return;
				this.curgoods_typeid = '';
				this.goodstypelist = [];
				goods.GetGoodsTypeByCorpid(this.curcorpid)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							if (ent.Data != 'null') {
								this.goodstypelist = JSON.parse(ent.Data);
								this.curgoods_typeid = this.goodstypelist[0].goods_typeid;

							} else
								this.goodstypelist = [];

						} else
							this.$message.info(ent.Msg);
					});
				this.InitCorpGoods();
			},
			getgoods(goods_typeid) {
				if (this.goodslisttemp.length < 1)
					return [];
				return this.goodslisttemp.filter(f => {
					if (f.goods_typeid == goods_typeid) {
						return f;
					}
				})
			},
			InitCorpGoods() {
				this.Initshowcount();
				this.goodslist = [];
				this.goodslisttemp = [];
				goods.GetGoodsByCorpid(this.curcorpid)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							if (ent.Data != 'null') {
								this.goodslist = JSON.parse(ent.Data);
								this.goodslist.forEach((temp, index) => {
									this.goodslist[index].goodsitemlist = []
								});
							} else
								this.goodslist = [];
							this.goodslisttemp = this.goodslist;
						} else
							this.$message.info(ent.Msg);
					});
			},
			AddGoodsShow() {
				this.goodsshowcount += 2;
			},
			Initshowcount() {
				this.goodsshowcount = 1;
			},
			GetShowGoods() {
				if (this.goodslist.length < 1)
					return [];

				return this.goodslist.filter((f, index) => {

					if (index < this.goodsshowcount) {
						return f;
					}
				})
			},
			SelGoodsTypeChange() {
				this.Initshowcount();
				if (this.curgoods_typeid == '')
					this.goodslist = this.goodslisttemp;
				else
					this.goodslist = this.getgoods(this.curgoods_typeid);
			}
		},
	}
</script>

<style>
</style>
